import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { PronosticoHidricoEstacionState } from '@/store/modules/pronostico-hidrico-estacion/types'

export const getters: GetterTree<PronosticoHidricoEstacionState, RootState> = {
  estacionResumen (state: PronosticoHidricoEstacionState) {
    return state.estacionResumen
  },
  linkDescarga (state: PronosticoHidricoEstacionState) {
    return state.link_descarga || ''
  }
}
